import React from 'react';
import '../../assets/css/ServiceDetails.css';

import ServiceDetailsImg1 from '../../assets/images/service/1.jpg';
import ServiceDetailsImg2 from '../../assets/images/service/2.jpg';
import ServiceDetailsImg3 from '../../assets/images/service/3.jpg';
import ServiceDetailsImg4 from '../../assets/images/service/4.jpg';
import ServiceDetailsImg5 from '../../assets/images/service/5.jpg';
import ServiceDetailsImg6 from '../../assets/images/service/6.jpg';
import ServiceDetailsImg7 from '../../assets/images/service/7.jpg';
import ServiceDetailsImg8 from '../../assets/images/service/8.jpg';
import ServiceDetailsImg9 from '../../assets/images/service/9.jpg';
import ServiceDetailsImg10 from '../../assets/images/service/10.jpg';
import ServiceDetailsImg11 from '../../assets/images/service/11.jpg';
import ServiceDetailsImg12 from '../../assets/images/service/12.jpg';
import ServiceDetailsImg13 from '../../assets/images/service/13.jpg';
import ServiceDetailsImg14 from '../../assets/images/service/14.jpg';
import ServiceDetailsImg15 from '../../assets/images/service/15.jpg';
import ServiceDetailsImg16 from '../../assets/images/service/16.jpg';
import ServiceDetailsImg17 from '../../assets/images/service/17.jpg';
import ServiceDetailsImg18 from '../../assets/images/service/18.jpg';
import ServiceDetailsImg19 from '../../assets/images/service/19.jpg';


const ServiceDetailsContent = () => {
    return (
        <div className="service-blog-container">
            <h2>Transforming Spaces Since 2020: Premium Cleaning & Gardening Solutions</h2>
            <p className="lead-text">
                For 5 years, we've revitalized hundreds of homes and businesses across Ottawa region with our 
                dual expertise in meticulous cleaning and sustainable gardening.
            </p>
            
            <div className="blog-image-gallery">
                <img  src={ServiceDetailsImg1} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg2} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg3} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg4} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg5} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg6} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg7} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg8} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg9} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg10} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg11} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg12} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg13} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg14} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg15} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg16} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg17} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg18} className="blog-style-image"  alt="" />
                <img  src={ServiceDetailsImg19} className="blog-style-image"  alt="" />
                
                
            </div>
        </div>
    )
}

export default ServiceDetailsContent;